import { useEffect, useState } from 'react';

import styled from '@emotion/styled';
import { Tooltip } from '@kc-console/common-ui';
import { isPreviewHost, useScopedLinkBuilder } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

const LogoContainer = styled('a')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  padding: '16px 24px',
  ':hover': {
    backgroundColor: theme.color['surface/global/transparent/strong/hover'],
  },
  ':active': {
    backgroundColor: theme.color['surface/global/transparent/strong/press'],
  },
  ...theme.mixins.focusRing('inside', { inverse: true }),
}));

const PreviewLogoText = styled('strong')({
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
  fontWeight: 700,
  width: 104,
});

const Logo = () => {
  const { t } = useTranslation();
  const { getProps } = useScopedLinkBuilder();
  // isPreviewHost는 window에 의존하므로 SSR과 첫 클라이언트 렌더를 일치시키기 위해 마운트 후에 반영합니다.
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    setIsPreview(isPreviewHost());
  }, []);

  return (
    <Tooltip message={t('layout:gnb.logo.navigate_msg')}>
      <LogoContainer {...getProps('/dashboard')} tabIndex={0}>
        {isPreview ? (
          <PreviewLogoText>Preview Console</PreviewLogoText>
        ) : (
          <img
            src="https://t1.kakaocdn.net/kic_console/brand/logo_white.svg"
            alt="kakao-cloud-gnb-logo"
            width={104}
            height={16}
          />
        )}
      </LogoContainer>
    </Tooltip>
  );
};

export default Logo;
